"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PropertyValue = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropertyValue = function PropertyValue(_ref) {
  var isLast = _ref.isLast,
      text = _ref.text,
      url = _ref.url;
  return url ? /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("a", {
    href: url,
    target: "_blank"
  }, text), !isLast ? ", " : "") : /*#__PURE__*/_react["default"].createElement("span", null, text + (!isLast ? ", " : ""));
};

exports.PropertyValue = PropertyValue;
PropertyValue.propTypes = {
  isLast: _propTypes["default"].bool.isRequired,
  text: _propTypes["default"].string.isRequired,
  url: _propTypes["default"].string
};
var TOP_RELEVANT_VALUES = 3;

var BioentityProperty = /*#__PURE__*/function (_React$Component) {
  _inherits(BioentityProperty, _React$Component);

  var _super = _createSuper(BioentityProperty);

  function BioentityProperty(props) {
    var _this;

    _classCallCheck(this, BioentityProperty);

    _this = _super.call(this, props);
    _this.state = {
      showAll: false
    };
    return _this;
  }

  _createClass(BioentityProperty, [{
    key: "_renderPropertyValues",
    value: function _renderPropertyValues(values) {
      return values.map(function (value, index) {
        return /*#__PURE__*/_react["default"].createElement(PropertyValue, {
          key: value.text,
          isLast: index >= values.length - 1,
          text: value.text,
          url: value.url
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var numberOfHiddenLinks = this.props.values.length - TOP_RELEVANT_VALUES;
      var hasOptionalLinks = ["go", "po"].includes(this.props.type) && numberOfHiddenLinks > 0;

      var showMoreLessButton = /*#__PURE__*/_react["default"].createElement("a", {
        key: "showButton",
        role: "button",
        style: {
          cursor: "pointer"
        },
        onClick: function onClick() {
          return _this2.setState(function (previousState) {
            return {
              showAll: !previousState.showAll
            };
          });
        }
      }, this.state.showAll ? " (show fewer)" : " \u2026 and ".concat(numberOfHiddenLinks, " more"));

      var allValuesWithOptionalLinks = this._renderPropertyValues(this.props.values); // Three most relevant links: the properties are sorted in descending order by relevance in the backend


      var topThreeValuesWithOptionalLinks = this._renderPropertyValues(this.props.values.slice(0, TOP_RELEVANT_VALUES));

      return /*#__PURE__*/_react["default"].createElement("div", null, !hasOptionalLinks && allValuesWithOptionalLinks, hasOptionalLinks && !this.state.showAll && [topThreeValuesWithOptionalLinks, showMoreLessButton], hasOptionalLinks && this.state.showAll && [allValuesWithOptionalLinks, showMoreLessButton]);
    }
  }]);

  return BioentityProperty;
}(_react["default"].Component);

exports["default"] = BioentityProperty;
BioentityProperty.propTypes = {
  type: _propTypes["default"].string.isRequired,
  values: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    text: _propTypes["default"].string.isRequired,
    url: _propTypes["default"].string.isRequired,
    relevance: _propTypes["default"].number.isRequired
  }))
};